import {gql} from "apollo-angular";
import {formulaPayableItemFields} from "../formula-payable-scheme/formula-payable-scheme.graphql";
import {baseResponse, baseResponseGraphqlField} from "../../../base.graphql";


export const formulaBasedFields = `
id
formularUniqueId
formularDescriptions
formularPayableItems {
  ${formulaPayableItemFields}
}
`

export const CREATE_FORMULA_SCHEME = gql`
  mutation CreateFormularBasedScheme($input: FormularBasedSchemeInputObjects!) {
    createFormularBasedScheme(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${formulaBasedFields}
      }
    }
  }
`

export const GET_FORMULA_SCHEME = gql`
  query GetInstitutionServiceFormulaBasedSchemes($billingUniqueId: String) {
    getInstitutionServiceFormulaBasedSchemes(billingUniqueId: $billingUniqueId) {
      ${baseResponseGraphqlField}
      data {
        ${formulaBasedFields}
      }
    }
  }
`;

export const CITIZEN_GET_INSTITUTION_SERVICE_FORMULA_BASED_SCHEME = gql`
  query CitizenGetInstitutionServiceFormulaBasedSchemes($billingUniqueId: String) {
    citizenGetInstitutionServiceFormulaBasedSchemes(billingUniqueId: $billingUniqueId) {
      response {
        ${baseResponse}
      }
      data {
        ${formulaBasedFields}
      }
    }
  }
`;